import { getCommonWidget } from "../../dashWidgetHelper";
import {
	commonWidgets, getProfuturoFacilidad, getProfuturoNpsPorMes, getProfuturoSatisfaccion,
	PRODUTURO_SCALE_3_COLORS, PRODUTURO_PIE_COLORS, PRODUTURO_PIE_SINO_COLORS, getProfuturoNpsAcumuladoFourMonth, getProfuturoCustomerJourney
} from "../commonWidgetsProfuturo";

const extrasFechas: { [key: string]: any } = {
	// Pisamos las fechas del filtro general ya que se usan los filtros dinámicos
	dateFrom: '2018-01-01',
	dateTo: '2120-12-31'
};

export default {
	title: 'Acompañamiento Dashboard',
	description: 'Acompañamiento Dashboard',
	backgroundClassName: (filters: FiltersUI) => 'epsilon-hero-bg',
	widgets: (filters: FiltersUI) => [
		{
			title: 'Principales Indicadores',
			size: [4, 1],
			type: 'label',
			config: { color: '#B7AADC' },
		},
		getProfuturoNpsAcumuladoFourMonth({
			position: [0, 1],
			size: [1, 2],
			indicator: 'est_cuenta_pregunta_14',
			extras: {
				periods: 6,
				...extrasFechas
			},

		}),
		getProfuturoNpsPorMes({
			size: [1, 2],
			indicator: 'est_cuenta_pregunta_14',
			extras: extrasFechas,
			historicGrouped: 'responseValue',
			historicGroupByResponseValueId: 173003100,
			historicLabel: 'group',
			historicExtras: extrasFechas
		}),

		getProfuturoSatisfaccion({
			size: [1, 2],
			indicator: 'est_cuenta_pregunta_2',
			helpText: '¿Qué tan satisfecho te encuentras con tu Estado de Cuenta?',
			extras: extrasFechas,
			historicGrouped: 'responseValue',
			historicGroupByResponseValueId: 173003100,
			historicLabel: 'group',
			historicExtras: extrasFechas,
		}),

		getProfuturoFacilidad({
			size: [1, 2],
			indicator: 'est_cuenta_pregunta_7',
			helpText: '¿Qué tan fácil te resultó descargar tu Estado de Cuenta desde tu mail?',
			extras: extrasFechas,
			historicGrouped: 'responseValue',
			historicGroupByResponseValueId: 173003100,
			historicLabel: 'group',
			historicExtras: extrasFechas,
		}),

		{
			title: 'Quiebres y Motivadores en la satisfacción',
			size: [4, 1],
			type: 'label',
			config: { color: '#B7AADC' },
		},
		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'pieGenericLarge',
			title: 'Satisfacción: clientes insatisfechos',
			size: [2, 2],
			helpText: '¿Por qué motivo calificaste  de esa manera?',
			indicator: 'est_cuenta_pregunta_22',
			extraConfigs: {
				colors: PRODUTURO_PIE_COLORS,
			},
			extras: extrasFechas,
		}),
		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'pieGenericLarge',
			title: 'Satisfacción: clientes neutros',
			size: [2, 2],
			helpText: 'Podríamos hacerlo mejor, ¿Nos dirías cómo?',
			indicator: 'est_cuenta_pregunta_20',
			extraConfigs: {
				colors: PRODUTURO_PIE_COLORS,
			},
			extras: extrasFechas,
		}),

		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'pieGenericLarge',
			title: 'Satisfacción: Clientes satisfechos',
			size: [2, 2],
			helpText: '¡Qué bueno que lo hicimos bien! ¿Por qué motivo calificaste de esa manera?',
			indicator: 'est_cuenta_pregunta_21',
			extraConfigs: {
				colors: PRODUTURO_PIE_COLORS,
			},
			extras: extrasFechas,
		}),
		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'pieGenericLarge',
			title: 'Satisfacción: Aspectos confusos. Clientes insatisfechos',
			size: [2, 2],
			helpText: '¿Qué aspectos del Estado de Cuenta te resultaron confusos o poco claros?',
			indicator: 'est_cuenta_pregunta_36',
			extraConfigs: {
				colors: PRODUTURO_PIE_COLORS,
			},
			extras: extrasFechas,
		}),
		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'pieGenericLarge',
			title: 'Satisfacción: Aspectos confusos. Clientes neutros',
			size: [2, 2],
			helpText: '¿Qué aspectos del Estado de Cuenta te resultaron confusos o poco claros?',
			indicator: 'est_cuenta_pregunta_40',
			extraConfigs: {
				colors: PRODUTURO_PIE_COLORS,
			},
			extras: extrasFechas,
		}),
		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'pieGenericLarge',
			title: 'Satisfacción: Aspectos claros. Clientes satisfechos',
			size: [2, 2],
			helpText: '¿Qué aspectos del Estado de Cuenta te resultaron más claros o útiles?',
			indicator: 'est_cuenta_pregunta_38',
			extraConfigs: {
				colors: PRODUTURO_PIE_COLORS,
			},
			extras: extrasFechas,
		}),

		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'pieGenericLarge',
			title: 'Facilidad: Clientes insatisfechos',
			size: [2, 2],
			helpText: '¿Por qué no resultó fácil?',
			indicator: 'est_cuenta_pregunta_34',
			extraConfigs: {
				colors: PRODUTURO_PIE_COLORS,
			},
			extras: extrasFechas,
		}),
		{
			title: 'Otras graficas',
			size: [4, 1],
			type: 'label'
		},
		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'pieGenericMedium',
			title: 'Medio de Contacto',
			size: [2, 2],
			helpText: '¿Por cuál medio preferirías recibir tu Estado de Cuenta?',
			indicator: 'est_cuenta_pregunta_23',
			extraConfigs: {
				colors: PRODUTURO_PIE_COLORS,
			},
			extras: extrasFechas,
		}),
		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'pieGenericMedium',
			title: 'Efectividad',
			size: [2, 2],
			helpText: '¿Has visitado la sección en profutro.mx sobre cómo leer el Estado de Cuenta?',
			indicator: 'est_cuenta_pregunta_27',
			extraConfigs: {
				colors: PRODUTURO_PIE_SINO_COLORS,
			},
			extras: extrasFechas,
		}),
		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'wordCount',
			title: 'Visita a profuturo.mx',
			size: [4, 2],
			helpText: '¿Qué te pareció?',
			indicator: 'est_cuenta_pregunta_35',
			extras: extrasFechas,
		}),
		getProfuturoCustomerJourney({
			id: 'cj-estadoDeCuenta',
			size: [3, 2],
			indicators: [{ name: 'est_cuenta_pregunta_2', formula: 'count-number', extrasFechas: extrasFechas }, //csat
			{ name: 'est_cuenta_pregunta_7', formula: 'count-number', extrasFechas: extrasFechas }, //facilidad
			{ name: 'est_cuenta_pregunta_14', formula: 'nps-10', extrasFechas: extrasFechas }, //nps
			],
			title: 'Customer Journey: Top Two Box',

		}),
		{
			title: 'Grado de Satisfacion',
			size: [4, 1],
			type: 'label'
		},
		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'stackedBar',
			title: 'La recepción del Estado de Cuenta cada 4 meses',
			size: [4, 1],
			helpText: '¿Qué tan satisfecho/a te encuentras con los siguientes aspectos respecto a tu Estado de Cuenta que recibiste?',
			indicator: 'est_cuenta_pregunta_30',
			extras: extrasFechas,
		}),
		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'stackedBar',
			title: 'La claridad de la información en el Estado de Cuenta',
			size: [4, 1],
			helpText: '¿Qué tan satisfecho/a te encuentras con los siguientes aspectos respecto a tu Estado de Cuenta que recibiste?',
			indicator: 'est_cuenta_pregunta_16',
			extras: extrasFechas,
		}),
		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'stackedBar',
			title: 'Las instrucciones para descargar el Estado de Cuenta son claras',
			size: [4, 1],
			helpText: '¿Qué tan satisfecho/a te encuentras con los siguientes aspectos respecto a tu Estado de Cuenta que recibiste?',
			indicator: 'est_cuenta_pregunta_24',
			extras: extrasFechas,
		}),
		{
			title: 'Grado de Acuerdo',
			size: [4, 1],
			type: 'label'
		},
		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'stackedBar',
			title: 'El Estado de Cuenta me muestra claramente lo que ahorré, lo que creció mi ahorro y lo que me cobraron',
			size: [4, 1],
			helpText: '¿Estás de acuerdo con los siguientes enunciados?',
			indicator: 'est_cuenta_pregunta_9',
			extraConfigs: {
				colors: PRODUTURO_SCALE_3_COLORS
			},
			extras: extrasFechas,
		}),
		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'stackedBar',
			title: 'El Estado de Cuenta me ayuda a saber si voy bien o mal para mi retiro',
			size: [4, 1],
			helpText: '¿Estás de acuerdo con los siguientes enunciados?',
			indicator: 'est_cuenta_pregunta_10',
			extraConfigs: {
				colors: PRODUTURO_SCALE_3_COLORS
			},
			extras: extrasFechas,
		}),
		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'stackedBar',
			title: 'El Estado de Cuenta me presenta alternativas de lo que debo hacer para mejorar mi futuro',
			size: [4, 1],
			helpText: '¿Estás de acuerdo con los siguientes enunciados?',
			indicator: 'est_cuenta_pregunta_11',
			extraConfigs: {
				colors: PRODUTURO_SCALE_3_COLORS
			},
			extras: extrasFechas,
		}),
		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'stackedBar',
			title: 'El Estado de Cuenta me deja tranquilo de que mi dinero está bien invertido y seguro',
			size: [4, 1],
			helpText: '¿Estás de acuerdo con los siguientes enunciados?',
			indicator: 'est_cuenta_pregunta_12',
			extraConfigs: {
				colors: PRODUTURO_SCALE_3_COLORS
			},
			extras: extrasFechas,
		}),
		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'stackedBar',
			title: 'Puedo consultar mi Estado de Cuenta en el momento que quiera en los diferentes canales que ofrece Profuturo',
			size: [4, 1],
			helpText: '¿Estás de acuerdo con los siguientes enunciados?',
			indicator: 'est_cuenta_pregunta_13',
			extraConfigs: {
				colors: PRODUTURO_SCALE_3_COLORS
			},
			extras: extrasFechas,
		}),
		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'stackedBar',
			title: 'Utilizo mi Estado de Cuenta para tomar  decisiones y planear sobre mi futuro',
			size: [4, 1],
			helpText: '¿Estás de acuerdo con los siguientes enunciados?',
			indicator: 'est_cuenta_pregunta_25',
			extraConfigs: {
				colors: PRODUTURO_SCALE_3_COLORS
			},
			extras: extrasFechas,
		}),

		getCommonWidget({
			commonWidgets: commonWidgets,
			name: 'textAnalysis',
			title: 'Análisis de Sentimientos',
			size: [4, 4],
			indicator: 'SENTIMENT',
			extras: extrasFechas,
		}),
	]
} as DasboardConfig
